
            const data = {"name":"glyph/16/filter","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M15 0H1C.4 0 0 .4 0 1v2c0 .3.1.6.4.8L6 8.5V15c0 .4.2.8.6.9.1.1.3.1.4.1.3 0 .5-.1.7-.3l2-2c.2-.2.3-.4.3-.7V8.5l5.6-4.7c.3-.2.4-.5.4-.8V1c0-.6-.4-1-1-1z\" class=\"nc-icon-wrapper\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    